import { CenterActivity } from '../../../lib/types/models/center-activity/center-activity'
import { CenterActivityInput } from '../../../lib/types/models/center-activity/center-activity-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createCenterActivity = async (input: CenterActivityInput & { centerId: number }) => {
  const { centerId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.centers.createCenterActivity.url, { centerId }))
    .post<CenterActivity, CenterActivityInput>(data)
}
